import * as React from 'react';

import SVGIcon from 'components/svg-icon/SVGIcon';

import { __t, applyTranslations } from 'utils/language';

import './tile-standard-content-channels-residual-icon.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

type Props = {
  type: string | undefined | null,
  url: string | undefined | null
};

const MSG_KEY = 'collabary_common';

const TileStandardContentChannelsResidualIcon = (
  {
    type,
    url
  }: Props
): JSX.Element => (
  <div
    className="tile-standard-content-channels-residual-icon"
    title={__t(`${MSG_KEY}.social.${String(type)}`)}
  >
    <SVGIcon
      name={`${String(type)}-no-customisation`}
      width={24}
      height={24}
      link={String(url)}
      className="tile-standard-content-channels-residual-icon__icon"
      clickable
      onClick={(event) => event.stopPropagation()}
    />
    <div className="tile-standard-content-channels-residual-icon__text">
      {type}
    </div>
  </div>
);

export default TileStandardContentChannelsResidualIcon;
